import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8895292"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardButton',
  props: {
  selected: { type: Boolean, default: false }
},
  emits: ['buttonClick'],
  setup(__props, { emit: __emit }) {

const emit = __emit

function buttonClick() {
  emit('buttonClick')
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (buttonClick())),
    class: _normalizeClass(["button-default header-button", { 'selected': __props.selected }])
  }, _hoisted_2, 2))
}
}

})